import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'components/components.module';
import { AdminRootPage } from 'pages/admin-root/admin-root';

@NgModule({
    declarations: [AdminRootPage],
    imports: [CommonModule, PagesModule, ComponentsModule],
    exports: [AdminRootPage]
})
export class AdminRootPageModule {}
